import { render, staticRenderFns } from "./TableUserCountApproximate.vue?vue&type=template&id=ef548478&scoped=true"
import script from "./TableUserCountApproximate.vue?vue&type=script&scoped=true&lang=js"
export * from "./TableUserCountApproximate.vue?vue&type=script&scoped=true&lang=js"
import style0 from "../assets/css/bootstrap.css?vue&type=style&index=0&id=ef548478&prod&scoped=true&lang=css&external"
import style1 from "../assets/css/styles.css?vue&type=style&index=1&id=ef548478&prod&scoped=true&lang=css&external"
import style2 from "../assets/css/fp.css?vue&type=style&index=2&id=ef548478&prod&scoped=true&lang=css&external"
import style3 from "../assets/css/neumorphism.css?vue&type=style&index=3&id=ef548478&prod&scoped=true&lang=css&external"
import style4 from "./TableUserCountApproximate.vue?vue&type=style&index=4&id=ef548478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_2dde62133769d2ad31600f93390d89d2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef548478",
  null
  
)

export default component.exports